import * as React from 'react'

function SvgMarker(props, svgRef) {
  return (
    <svg viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M7 .5A6.526 6.526 0 00.481 7.019c0 4.46 5.834 11.01 6.082 11.286.234.26.641.26.874 0 .248-.276 6.082-6.825 6.082-11.286A6.526 6.526 0 007 .5zm0 9.799a3.284 3.284 0 01-3.28-3.28A3.284 3.284 0 017 3.739a3.284 3.284 0 013.28 3.28A3.283 3.283 0 017 10.299z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgMarker)
export default ForwardRef
